export const FETCH_API_BASE_URL = 'https://www.jugendfreizeithof-grillenburg.de/cms'

export const FETCH_API_PAGES_URL = '/api/collections/get/pages'
export const FETCH_API_CALENDAR_URL = '/api/collections/get/calendar'
export const SUBMIT_CONTACT_FORM = '/api/forms/submit/mail?token=2131a1c2dbe8972e033059483c5cc8'



// WEBPACK FOOTER //
// ./src/fetchAPI/constants.js